


























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState ,AppSettings,HellospokeUser} from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';
import moment from "moment";
import ManagingTag from  '../Tag/ManaginTag.vue';
import QuickCall from '../QuickCall.vue';
import utill from '../../lib/util'; 
import ContactModal from './Contact_modal.vue';
import util from "../../lib/util";
import axios from  'axios'; 
import CompanycontactEdit from "./Company_Edit.vue";   
import conactdetail from '../contact/contactDetail.vue';




declare interface AdminData { 
		users: HellospokeUser[];
  }


 @Component({ 
  components: {
   RotateSquare2,VueElementLoading,QuickCall,ContactModal,ManagingTag ,CompanycontactEdit
  },
  computed: {
  ...mapState({
    '___contacts': (state: StoreState) => state.dashboard.contacts,
  'devices': (state: StoreState) => (state.account as any).devices,
  'contactsidebar_status': (state: StoreState) => state.dashboard.contactsidebar_status,
  'Account_id': (state: StoreState) => state.account.account_id ,
  'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
  'User_id': (state: StoreState) => state.dashboard.logger_userid ,
  'PersonalContact_List': (state: StoreState) =>state.dashboard.PersonalContact_List,
  'SharedContact_List': (state: StoreState) =>state.dashboard.SharedContact_List,
  'FavoirteContact_List': (state: StoreState) =>state.dashboard.FavoirteContact_List,
  'companyContact_List':(state:StoreState)=> state.dashboard.companyContact_List,
  'FavoirteContact_Count': (state: StoreState) => state.dashboard.FavoirteContact_Count,
  'notificationContact':(state:StoreState)=>state.dashboard.selectednotificationContact,
  'setmultiplecontact':(state:StoreState)=> state.dashboard.ismultipledelete,


  'Contact_loader': (state: StoreState) =>state.dashboard.Contact_loader,
  //  Presence User
  'jwt': (state: StoreState) => state.account.jwt,
  'conferenceattendeesectionlist': (state: StoreState) => state.dashboard.AttendeeSectionList,
  'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
  'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
  'channels': (state: StoreState) => state.dashboard.Channels,
  'ongoincalls': (state: StoreState) => state.dashboard.OnGoinCalls,
  'user_image_url': (state: StoreState) => state.dashboard.user_image_url, 
   'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
   'tagname':(state:StoreState) => state.dashboard.tagname,    
   'tagstatus': (state: StoreState) => state.dashboard.Tag_status,
   'handletagsidebar' : (state: StoreState) => state.dashboard.handletagsidebar,
    'textpannel_contactinfo': (state: StoreState) => state.dashboard.textpannel_contactinfo ,
    'textmessagtab' :(state:StoreState)=> state.dashboard.textmsgtab,
     'privilege_level':(state: StoreState) => state.account.privilege_level,
     'textpanelcontact':(state:StoreState) => state.dashboard.from_textpanel_contact
  })
  },
   beforeMount: async function () {
     console.log('checking mounting before');
     await this.$store.commit("TAB_MANAG",{evt:''})
     await this.$store.commit("TAB_STATUS", false);
   },
   mounted: function() {
      console.log('previlege',(this as any).privilege_level);
    //this.fetchKazoo();
    this.$data.searchloader = true;
     this.$store.dispatch('gettag').then(r=>{
        this.$data.taglist = r.data.docs;
         this.$data.searchloader = true;
      })
      .catch(err=>{
        console.log(err);
      })

       this.$root.$on('contact_table', (data) => {
         this.refreshcontact_tags(data.tagid,data.type);
        })
        this.$root.$on('selectAlltablecheckbox',(data)=>{
        this.individual_select(data.selectcont,data.type);
       })
        this.$root.$on('UnselectAlltablecheckbox',(data)=>{
        this.unselctcontact(data);
       })


      this._GetContacts();
      this.$store.dispatch("getChannelDevices");
      this.$store.dispatch("getChannels").then(r=>{ //this.SetCallDetails();
      });
      this.$store.dispatch("createBlackholeSocket");
      this.$store.dispatch('getTextPermissions');
      this.$store.dispatch('createNotificationsSocket');
      
      this.$store.dispatch('checkNotifications').then(async (r) => {
        this.$store.commit('SET_NOTIFICATION_REFRESH',false); 
          }
        );
        this.$data.searchloader = true;
      },
      beforeCreate:function(){
           
      }
 })
export default class ContactTable extends Vue {
     private conferenceattendeesectionlist: any[];

 data() {
 return {
      fullNames: [],     
      companyfullNames:[],
      editcompany:false,
      contacts: [],
      loading:false,
      multipleselect:[],
      selectallcontact:[],
      selected: [],
      selectAll: false,
      managintab_status:false,
      managintab_statusall:false,
      Contact_Shared:[],
      Contact_Personal:[],
      exists:false,
      Deletemodal:false,
      deletemultiple:false,
      selcetdcont_loading:'',
      taglist:[],
      nameascending:true,
      phoneascending:true,
      compascending:true,
      search_term:'',
      mainfullnamearr:[],
      modalflag: 0,
      clickstatus: false,
      err:'',
      searchloader:false,
      mainContactList: [],
      activetab:"",
      oldtaglist: [],
      scrolledToBottom:true,
      mesga_hover:true,
      onhover_assgnId:'',
      searcheditems:''
    }
 }

  @Prop()
    public users!: HellospokeUser[];


@Watch("selectedContact")
changeselectedContact()
{  
  if((this as any).selectedContact && (this as any).selectedContact.length == 0){
      this.$data.multipleselect = [];
      this.$data.selectAll = false;      
  }
}
@Watch('tagstatus')
 onChangetagstaus()
 {
   if(!(this as any).tagstatus)
   {
      this.$data.managintab_statusall = false;
       var found = this.$data.fullNames;
       	for (let i in found) {
           if(found[i].select)
           {
                found[i].select=false;
           }
         }
      this.$data.selectAll=false;
      this.$data.multipleselect=[];
      this.$data.managintab_statusall = false;

   }
 }

  @Watch('contactsidebar_status')
  Onchange(){
    this.$data.multipleselect= [];    
    this.$data.search_term = ""
    this.Refresh_list();
  }

  mouselevae(){
    debugger
    //  this.$data.selectAll=false;
      this.$data.managintab_statusall = false;
      //  this.$data.multipleselect.filter(function (el,index) { el.select=false;
      //  var selectedcon = el._id;
      //  let elment = document.getElementById(selectedcon)
      // if(elment){ elment.classList.remove('checkboxbg')}
      //  });
      //  this.$data.multipleselect=[];
  }
    mesgahover(id,st){
    this.$data.onhover_assgnId=id;
    this.$data.mesga_hover=st;
    }
  group_chat(){
    this.$data.Deletemodal=true;
    var setvariable=(this.$data.multipleselect.length)>10?'alert_grupchat':'gruop_chat';
    this.$store.commit('CONTACT_MODAL_STATSUS',setvariable);
  }

  contcat_modal(){
   this.$data.Deletemodal=true;
   this.$store.commit('CONTACT_MODAL_STATSUS','delete_contact');
  }

  onClickSMS(selectedcontactlist)
  {
   let conta = selectedcontactlist;      
   this.$store.commit("CHANGE_SELECTED_CONTACT", conta);
   this.$emit('editcontact');
   this.$data.activetab = "textmsg";
   this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab)
      
  }
  onclickmultiplecheckbox(checked)
  {
    this.selectall(checked);
    this.$store.commit("SET_MULTIPLEDELETE",true);    
     for(let i =0;i<this.$data.fullNames.length;i++)
      {
        var ch = this.$data.fullNames[i];
        if(ch.select == false)
        {
           var check = ch._id;
      let ele = document.getElementById(check);
      ele.classList.add('checkboxbg');
        }
        else{
           var check = ch._id;
      let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');
        }
      }

  }
  onclickCheckbox(name,multi)
  {
    this.$store.commit("SET_MULTIPLEDELETE",true);
    if(name.select == false)
    {
      var check = name._id;
      let ele = document.getElementById(check);
      ele.classList.add('checkboxbg');
    }
    else{
       var check = name._id;
      let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');
    }
  }
  setTag(tags, contact)
  {
    let contacttagarr = contact.map(e=>e.taglist).filter((x) => { return x !== undefined; }).flat();
    for(let i = 0; i < tags.length; i++)
    {
      let tag_id = tags[i]._id;
      tags[i].contact_count = !tags[i].contact_count || tags[i].contact_count == 0 ? contacttagarr.filter(function(x){return x==tag_id}).length : tags[i].contact_count;
    }
    
    util.handletag(tags, 'set');
    this.$store.commit('HANDLE_TAG_SIDEBAR' ,!(this as any).handletagsidebar);

  }
  
 getColor(tagname,id="")
  {  
   let tags = util.handletag();
   let index = tags.map(e=>e._id).indexOf(id) ;
   return tags[index].color;
  if(!id) return false; 
  //return utill.userColor(tagname,id);
  }
  getTagbyId(tagid, i = 0)
  {
    let tags = util.handletag();
    if(tags.map(e=>e._id).indexOf(tagid) > -1) return { type: "tag", tag: tags[tags.map(e=>e._id).indexOf(tagid)] }
    return {type: "empty", tag: []};
  }
 insertTagCount(contact)
{
  let tags = util.handletag();
  if(tags.length == 0){
    this.$store.dispatch('gettag').then(r=>{
      this.$data.loading_tag=false;
      let taglist = r.data.docs;
      if(taglist.length == 0) return false;
      this.setTag(tags, contact);
      // this.$store.commit('TAB_STATUS' ,!(this as any).tagstatus);
    })
    .catch(err=>{
      console.log(err);
    })
    return false;
  }
  this.setTag(tags, contact);
}
fetchKazoo()
{
  /*var payload = {id: (this as any).Account_id};
  this.$store.dispatch("getKazooUser", payload);*/
}
editcompanyclose_evet(evt){
   this.$data.editcompany=false;
  (this.$refs.refreshlist as any).refreshcontact(evt);
 }
  /*
  * Refresh list based on which tab is active
  */
   Refresh_list(){
    this.$data.selectAll=false;// this.$data.multipleselect.length==this.$data.fullNames.length?true:false
    this._GetContacts();
  }
    handlecustomdd() //type, index
    { 
        let classstatus = document.querySelector(".mtagclass") || document.querySelector(".mtagcompanyclass") ;
        let tag_svgGreen = document.querySelector(".tag_svgGreen");
        if(classstatus && tag_svgGreen && this.$data.managintab_statusall && !this.$data.clickstatus)
        {
           this.$data.fullNames.forEach(element => {
         this.$data.deletemultiple=false;
         element.select = false;
         this.$data.selectAll=false;
         this.$data.multipleselect = [];
         var check="";
         
            check = element._id;
            let ele = document.getElementById(check);
          ele.classList.remove('checkboxbg');
           })
    
          this.$data.managintab_statusall = false;
        }
        else
        {
          this.$data.clickstatus = false;
          
        }
    
    }

 
 
 async refreshcontact_tags(tags, evt){
  //this.$data.managintab_status=false;
  var setlct_contact=(this as any).selectedContact;
  
    console.log('evthere',tags,evt);
    /*
    remove tag from selcetd contacts
    unckeck checkbox of selecetd contact
    uncheck  main checkbox
    */     
    if(evt=='multiplecontacttag_remove'){        
       this.$data.multipleselect.forEach(element => {
     var found = this.$data.fullNames.find(function(el) {
        return el._id ==element._id;
      });
      if(found.taglist!=undefined){
        var matchtag=false;
        found.taglist.filter(function (el,index) { 
            if(el === tags){
              matchtag=true;
              found.taglist.splice(index,1);
            }
      });
       this.$data.selectAll=false;
      this.$data.multipleselect=[];
     this.$data.managintab_statusall = false;
    }
   });
  }
 
    /*
    add tag to contact 
    */  
    if(evt=='assign'){
      var total_taglist=util.handletag();
     
       var found :any = {};
        found = this.$data.fullNames.find(function(element) {
        return element._id ==setlct_contact._id;
      });
      
    /* 
      if selected contact has taglist
      compare with all tags based on id and update existing contact taglist.
    */
     let checkExist = {};
     checkExist = await found.tags1.filter(function(cont) { 
        return cont._id===tags
     })

     let checkTagExist = {};
        checkTagExist = await found.taglist.filter(function(contl) { console.log('taglistid',contl);
          return contl==tags
      })
    
     if(Object.keys(checkExist).length==0) {
          total_taglist.filter(function (el) { 
              if(el._id=== tags){
                found.tags1.push(el); 
              }
        });
        console.log('found.tags1',found.tags1);
     }

     if(Object.keys(checkTagExist).length==0) {
              total_taglist.filter(function (el) { 
              if(el._id=== tags){ 
                  found.taglist.push(el._id); 
              }
        });
      }
      
        
    
     found.select=false;
      this.$data.multipleselect=[];     
      this.$data.managintab_statusall = false;

    }

  /*
  remove tag from Contact 
  */
    if(evt=='remove'){
        var found = this.$data.fullNames.find(function(element) {
        return element._id ==setlct_contact._id;
      });
      if(setlct_contact.taglist!=undefined){
      found.tags1.filter(function (el,index) { 
          if(el._id === tags){
          found.tags1.splice(index,1); 
          }
      });
    }
    found.select=false;
    }
    
  if(evt=='multiplecontacttag_asssign'){
   this.$data.multipleselect.forEach(element => {
     var found = this.$data.fullNames.find(function(el) {
        return el._id ==element._id;
      });
      if(found.taglist!=undefined){
        var matchtag=false;
        found.taglist.filter(function (el,index) { 
            if(el === tags){
              matchtag=true;
            }
      });
      if(!matchtag){
      this.$data.taglist.filter(function (el) { 
            if(el._id === tags){
            found.tags1.push(el); 
            found.taglist.push(tags);
            
            }
      });
      }
      found.select=false;
      this.$data.selectAll=false;
      this.$data.multipleselect=[];
     this.$data.managintab_statusall = false;
    }
    
    /* 
    if selected contact has no taglist
    assign taglist and compare with tags id make contacttaglist
    */
    else{
      this.$data.taglist.filter(function (el) { 
            if(el._id === tags){
            found.taglist=[tags];
            found.tags1=[el]; 
            }
      });
     
    } 
   });
  }    
}

 //Update contact Info after edit Or Refresh list after save new conatct
 public refreshcontact(evt, data){ console.log('evt data delete tag',evt);
  /*
  * Refresh list afret saving New contact
  */
  if(evt=='refresh_listdata'){
    this.Refresh_list();
   }
  /*
  * Delete contact from EditContact modal
  * contact has to remove from list
  */
  if(evt=='delet_refresh'){  
    var setlct_contact=(this as any).selectedContact;
    this.Remove_contact(setlct_contact);
  }
  /*
  * On unpading contact information ,the updated informtion has to reflect in list
  * without refreshing or without calling an API
  */
  if(evt=='UpdateContactInfo'){
  var setlct_contact=(this as any).selectedContact;
  const id= (this as any).selectedContact._id;
  var USERID=(this as any).User_id;
    var found = this.$data.fullNames.find(function(element) {
        return element._id ==id;
      });
      // debugger
    found.first_name=  `${setlct_contact.first_name}` ;
    found.last_name=  `${setlct_contact.last_name}`;
    found.numbers.mobile.number= `${setlct_contact.numbers.mobile.number}`;
    found.email[0]= `${setlct_contact.email[0]}`;
    found.compny_name= `${setlct_contact.compny_name}`;
    found.imageUrl= setlct_contact.imageUrl!=undefined?setlct_contact.imageUrl:'' ;
    found.pvt_cont=setlct_contact.pvt_cont;
    found.tags1=setlct_contact.tags1;
    found.taglist = setlct_contact.taglist;
    /*
    * while making favorite as unfavorite contact.
    * if the active tab is 'favorites' unfavorite contact has to remove from list
   */
    if((this as any).contactsidebar_status=='favorites'){
      //this.Remove_contact(setlct_contact);
    }
   }
  
  if(evt=="sharedcont_refresh"){
     this.$store.commit('CONTACT_SIDEBARSTATSU', 'shared');
      this._GetContacts();
   }

  /*
  If tag name is update ,then tag of that contact has to update without refresh  
  */
  if(evt="UpdateTagContacts"){
      this.$data.fullNames.filter(function (el) {
        if(el.tags1.length!=0){
          el.tags1.find(function(element) {
         if(data && element._id ==data.payload._id){
          element.tag=data.payload.tag;
          } 
          });
        }
      });
  }
  /*
  If tag delete,then tag of that contact has to delete without refresh  
  */
  if(evt="DeleteTagContacts"){
      /*this.$data.fullNames.filter(function (el,index) {
        if(el.tags1.length!=0){
          el.tags1.find(function(element,index1) {
            // console.log(element)
            // console.log(data);
         if(data && element && data.payload && element._id && element._id ==data.payload._id){
         // element.tag=data.payload.tag;
           el.tags1.splice(index1,1);
          } 
          });
        }
      });*/
          var tagname_listttt=(this as any).tagname;
          console.log('tagname_listttt',tagname_listttt);
          if((tagname_listttt.length>0 &&((this as any).contactsidebar_status=='all')) || ((this as any).contactsidebar_status!='all')) {
            var result = this.$data.fullNames.filter(function (o1) {
                        return tagname_listttt.every(function (o2) {
                            return o1.taglist && o1.taglist.includes(o2)
                          
                      });
                    });
          this.$data.fullNames=this.Sortlist(result);
          } else {
            this.$data.fullNames = [];
          }
          
          
          
          //this._GetContacts();
  }

 }

 //remove selected contact from list
 Remove_contact(contact_info){
  
     let tindex = this.$data.fullNames.map(e=>e._id).indexOf(contact_info._id);
      this.$data.fullNames.splice(tindex,1);
    //    this.$data.fullNames.forEach((e,index1) => { 
         
    //     if(contact_info._id==e._id){
    //        this.$data.fullNames.splice(index1,1);
    //        this.$data.multipleselect = [];
           
    //     }
    //   });
    /*
    * count has to update with respective of which tab is actived
    */
    switch((this as any).contactsidebar_status)
    {
      case 'company':
       //  context.commit('FAVORITECONTACT_LIST', r.data.Contact_Favorite);
        break;
      case 'shared':
        this.$store.commit('SHAREDCONTACT_LIST' ,this.$data.fullNames );
        this.$store.commit('SHAREDCONTACT_COUNT', this.$data.fullNames.length);
        break;
      case 'favorites':
        this.$store.commit('FAVORITECONTACT_LIST', this.$data.fullNames);
        this.$store.commit('FAVORITECONTACT_COUNT', this.$data.fullNames.length);
        break;
      case 'personal':
        this.$store.commit('PERSONALCONTACT_LIST',this.$data.fullNames);
        console.log('personal contact dgdf', this.$data.fullNames);
        this.$store.commit('PERSONALCONTACT_COUNT',this.$data.fullNames.length);  
        break;
      default:
      break;
    }

 }


 gettags(taglist)
 {
   var mm=taglist!=undefined?util.handletag(taglist):[];
   return mm;//util.handletag(taglist);
 }


 @Watch('tagname')
updatetagname()
{
  debugger
  var tagname_listttt=(this as any).tagname
   this.$data.searchloader = true; 
   //let tags = util.handletag();
   debugger
  //  let tag_id = tags.filter(e=>{
  //    debugger
  //    var abb=(this as any).tagname;
  //    return e.tag == (this as any).tagname})[0]._id;
  //  console.log(tag_id);
       if((tagname_listttt.length>0 &&((this as any).contactsidebar_status=='all')) || ((this as any).contactsidebar_status!='all')) {
             this.$store.dispatch("getContacts").then(async r => {
                let contact:any = r.data.docs;
                this.$data.searchloader = false; 
                  var result = await contact.filter(function (o1) {
                      return tagname_listttt.every(function (o2) {
                          return o1.taglist && o1.taglist.includes(o2) 
                        
                    });
                  });
                  console.log(result);
                  this.$data.fullNames=this.Sortlist(result);
                  console.log('r.data.docs contact table all reached here',this.$data.fullNames);

              })
        } else {
           this.$data.fullNames = [];
        }
   
    //   console.log(result);
    //     //data = data.filter(e=>{ return e.taglist && e.taglist.indexOf(tag_id) > -1 });
    //     // if(data && data.length == 0)
    //     // {
    //     //   this.$data.err = "No items to display"
    //     // }
    //     // else
    //     // {
    //       this.$data.fullNames=this.Sortlist(data);
    //   //  }
    //  }).catch(e=>{ 
    //   // this.$data.searchloader = false;  
    //    });
     /*comment -  var result = this.$data.fullNames.filter(function (o1) {
          return tagname_listttt.some(function (o2) {
              return o1.taglist && o1.taglist.indexOf(o2) > -1 
            
        });
      });
      console.log(result);
      this.$data.fullNames=this.Sortlist(result);*/
}


/////////////////////// Presence User code

 @Watch('user_image_url')
  updateuserimage()
  {
    var id=(this as any).userid;  
    this.$data.fullNames
        var UserImagefound = this.$data.fullNames.find(function(element) {
            return element._id ==id;  
          });
      if (UserImagefound)
        UserImagefound.imageUrl= (this as any).user_image_url;
  }

  @Watch ('ongoincalls')
  SetCallDetailsforincommingcalls()
  {
    var _ongoincalls= JSON.parse(JSON.stringify((this as any).ongoincalls))
    if (_ongoincalls.length)
    {
      var _call = _ongoincalls.pop();
      if (_call && (_call.name === 'CHANNEL_CREATE' ||  _call.event_name === 'CHANNEL_CREATE') )
      {
           this.processCall(_call);
      }
      else  if (_call && ( _call.name === 'CHANNEL_DESTROY' ||_call.event_name === 'CHANNEL_DESTROY' ) 
                      && _call.disposition == "SUCCESS") 
      {
          this.EndCall(_call);
      }
    }

 }
 
 
  @Watch ('channels')
  SetCallDetails()
  {
    var _channels = (this as any).channels;
    _channels.forEach(element => {
           this.processCall(element);
    });
  }

  async processCall(element:any)
    {
       var _devices  =(this as any).devices;
       //companyfullNames
       var _user = this.$data.fullNames.find((e: any) => {
             return !e.call && ( (element.presence_id &&  element.presence_id.includes(e.presence_id))||
            (element.from &&  element.from.includes(e.presence_id ))) ;
          });
          // console.log("_use --- ", _user);
          if(_user!=undefined && !_user.call){
              _user.call_id= element.call_id;
              _user.interaction_id= element.interaction_id;
              _user.call_details= {
              from:element.caller_id_name? element.caller_id_name : element.from,
              to:element.callee_id_name? element.callee_id_name : element.to,
              time:element.elapsed_s? element.elapsed_s :1
            };
            _user.call=true;
            // console.log("start call --- ",_user);
            let companynames = JSON.parse(JSON.stringify(this.$data.fullNames));
            this.$data.fullNames = [];
            this.$data.fullNames = companynames;
          }                  

    }

       
  alterTime(dur) {
      let time = dur; //moment.duration(957146, 'seconds');
      return (time as any).format("dd:hh:mm:ss"); //`${time.day}:${time.hour}:${time.minute}:${time.seconds}`;
    }
  async EndCall(element:any)
  {
    //fullNames
    //companyfullNames
       var _user = this.$data.fullNames.find((e: any) => {
           return (element.call_id ===e.call_id) || (element.custom_channel_vars.call_interaction_id===e.interaction_id);
       });
       debugger
        if (_user && _user.call) {
            _user.call=false;
            // console.log("endcall --- ", _user);
            // console.log(element);
            delete _user.call_id;
            delete _user.call_details; 
            delete _user.interaction_id;
            var fname= _user.full_name;
            _user.full_name=fname + ' ';
            _user.full_name=fname;
            let callee_id_number = element.callee_id_number;
            let caller_id_number = element.caller_id_number;
            this.$data.fullNames.filter(e=>
            { 
              if((e.presence_id == callee_id_number || e.presence_id == caller_id_number) && e.call)
              {
                e.call = false;
                delete e.call_id;
                delete e.call_details; 
                delete e.interaction_id;
              } 
            })
        }
        let companynames = this.$data.fullNames;
            this.$data.fullNames = [];
            this.$data.fullNames = companynames;
  }
   
  quickCall(number) {
      this.$store.commit('QUICK_CALL', number);
    }
 
  // ===============================End Presence User code


  searchContacts()
 {
   debugger
  //  this.$data.err = "";
      this.$data.searcheditems = this.$data.search_term.toLowerCase(); 
      this.$data.searcheditems = this.$data.searcheditems.replace(/\s+/g, '')
     //this.$store.commit('SET_CONTACT_LOADER', true);
       this.$data.searchloader = true;
     if (this.$data.search_term.length != 0) {
      var self = this;
      var search_term = this.$data.searcheditems;      
      if (search_term != '' || search_term != undefined) {           
    // this.$data.mainfullnamearr =[...this.$data.fullNames];
    this.$data.fullNames = this.$data.mainfullnamearr.filter(function (cust) {
      var last_name = "";
    var fullname = cust.first_name + cust.last_name;
      if(cust.first_name!= undefined)
      {
        var first_name = cust.first_name.toLowerCase(); 
      }
      else{
        first_name = "";
      }
      if(cust.first_name!= undefined && cust.last_name!= undefined)
      {
        first_name = cust.first_name.toLowerCase();
        last_name = cust.last_name.toLowerCase(); 
        fullname = first_name + last_name;
      }
       if(cust.last_name!= undefined)
      {
        last_name = cust.last_name.toLowerCase(); 
      }
      if(cust.email[0]!= undefined)
      {
         var email      = cust.email[0].toLowerCase(); 
      }
      else{
        email = "";
      }        
    var phone      = cust.numbers.mobile.number;
    if(cust.compny_name!= undefined){
    var company    = cust.compny_name.toLowerCase(); 
    company = company.replace(/\s+/g, '');
    }
    else{
       company = "";
    }   
        if (first_name.indexOf(search_term) >= 0 || last_name.indexOf(search_term) >= 0 
        || fullname.indexOf(search_term) >= 0 || phone.indexOf(search_term)>= 0 || email.indexOf(search_term) >= 0 || company.indexOf(search_term) >= 0) {
          return cust;
        }
      });
      }
      setTimeout(function()
      {
          this.$data.searchloader = this.$data.Contact_loader=false; 
      }.bind(this),1000)
        
    }
    else{  
      this.Refresh_list();
    }
 }

  //Open delete modal
  deletemodal_open(info){
    //Uncheck selected contact on click of checkbox
    this.$data.multipleselect=[];
     this.$data.fullNames = this.$data.fullNames.filter(function (el) {
             el.select=false; //by defaut false 
            return el;
      });

    //Delete single contact by id
      this.$data.fullNames.forEach(element => {
      if (element._id == info._id) {
        // debugger
        this.$store.commit("CHANGE_SELECTED_CONTACT", element);  
         this.$data.Deletemodal=true;
         this.$data.deletemultiple=false;
         var check="";
         
            check = element._id;
            let ele = document.getElementById(check);
          ele.classList.remove('checkboxbg');
          this.$store.commit('CONTACT_MODAL_STATSUS','delete_contact');
          
      }
      }); 
  }
 
 //Remove delete contact from list or Cancel modal
  DeleteContactModal_Event(ev){
     console.log('here in delete',ev);
    if(ev=='cancel'){this.$data.Deletemodal=false; //delete cancel part
    var check="";
     this.$data.fullNames.forEach(element => {
      if(element.select == true)
      {
         check = element._id;
         let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');
      }
     });
      
      this.$data.deletemultiple=false;
       this.$data.selected = [];
       	for (let i in this.$data.fullNames) {
          //this.$data.contacts[i].select=st;
           this.$data.fullNames[i].select=[]; 
         }
          this.$data.selectAll=false;
      this.$data.multipleselect=[];
      }
    else{ // delete part
      let taglist = [];
      if((this as any).selectedContact)
      {
        taglist = (this as any).selectedContact.taglist && (this as any).selectedContact.taglist.length > 0 ? (this as any).selectedContact.taglist : [];
      }
      else
      {
        taglist = this.$data.multipleselect.map(e=>e.taglist).filter((x) => { return x !== undefined; }).flat() && this.$data.multipleselect.map(e=>e.taglist).filter((x) => { return x !== undefined; }).flat().length > 0 ? this.$data.multipleselect.map(e=>e.taglist).filter((x) => { return x !== undefined; }).flat() : [];
      }
      let tags = util.handletag();
      for(let i = 0; i < taglist.length; i++)
      {
        let index = tags.map(e=>e._id).indexOf(taglist[i]);
        if(index > -1)
        {
          tags[index].contact_count -= 1;
        }
      }
      this.$data.Deletemodal=false;
      //this.$store.commit('CONTACT_SIDEBARSTATSU', 'personal');
      //Remove multiple contact
      var data=(this as any).selectedContact;
    if(this.$data.multipleselect!=0){
       this.$data.multipleselect.forEach((object,index) => {        
        let taglist = object.taglist;
        if(object.taglist!= undefined){
        for(let i = 0; i < taglist.length; i++)
        {
          let index = tags.map(e=>e._id).indexOf(taglist[i]);
          if(index > -1)
          {
            tags[index].contact_count -= 1;
          }
        }
        }
        this.$data.fullNames.forEach((number,index1) => {
          if(object._id==number._id){
            var check = object._id;
            let ele = document.getElementById(check);
            ele.classList.remove('checkboxbg');
            this.$data.fullNames.splice(index1,1);
          }
        })
      })
      }
      else{
        let tindex = this.$data.fullNames.map(e=>e._id).indexOf(data._id);
        debugger
      this.$data.fullNames.splice(tindex,1);
      }
      util.handletag(tags, 'set');
      this.$store.commit('HANDLE_TAG_SIDEBAR' ,!(this as any).handletagsidebar);
      this.$data.selectAll=false;
      this.$data.multipleselect = [];
      //this.$store.commit('CONTACT_SIDEBARSTATSU', 'personal');
      //Remove selected contact
      
      this.Remove_contact(data);
    }
  }


  addsharedcontact(){
    this.$data.multipleselect.filter(e=>{
      if(e.presence_id) delete e.presence_id;
    })
    // console.log(mulselect);
    this.$emit('tabmanag', {type: 'addtosharedcontacts', multiselect: this.$data.multipleselect, shared: (this as any).SharedContact_List});
    //this.$emit('tabmanag',  'addtosharedcontacts');
  }


 //Add to favorite contact
  AddtoFavoritecont(contact_info){
    this.$data.selcetdcont_loading=contact_info._id;;
   this.$store.dispatch('addtoFavoritContac', contact_info._id).then(r => {
       this.$data.selcetdcont_loading='';
         var found = this.$data.fullNames.find(function(element) {
          return element._id ==contact_info._id;
        });
     //Fovorite count should increase to 1
    // alert((this as any).FavoirteContact_Count)
     this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count+1);
     found.pvt_cont= true ;
      }).catch(() => {
        });
  }

  
 //Remove from favorite contact
  RemoveFavorite(contact_info){
  this.$data.selcetdcont_loading=contact_info._id;;
  var USERID=(this as any).User_id;
   this.$store.dispatch('removeFavoritContac', contact_info._id).then(async r => {
     this.$data.selcetdcont_loading='';
     var found = this.$data.fullNames.find(function(element,index) {
          return element._id ==contact_info._id;
        });
     found.pvt_cont= false ;
    //if active tab is "Fovorite"  remove unfavorite contact from list
    if((this as any).contactsidebar_status=='favorites'){
       await this.Remove_contact(contact_info);
       /*let favorite_count = this.$data.fullNames.length-1;
       console.log("favorite count --- ", favorite_count);
       this.$store.commit('FAVORITECONTACT_COUNT', favorite_count);*/
    }    
    else{
       //Fovorite count should reduce to 1
     this.$store.commit('FAVORITECONTACT_COUNT',(this as any).FavoirteContact_Count-1);
    }
   
      }).catch(() => {
   });
  }

 comparer(otherArray){
  return function(current){
    return otherArray.filter(function(other){
      return other.value == current.value && other.display == current.display
    }).length == 0;
  }
}
  //Edit contact infromation ,
  editcontact(contact_info, from,selected){
    if(selected == 'nameselected') {
      this.$store.commit('SET_TEXTMESSAGETAB','details');
    }
    else{
    this.$store.commit('SET_TEXTMESSAGETAB','editcontct');
    }
    this.$data.editcompany = false;
    this.$data.selcetdcont_loading=contact_info._id;;
    var USERID=(this as any).User_id;
    this.$store.commit("CHANGE_SELECTED_CONTACT", null); 
    if(from=='Text_panel'){
     this.Edit_ContDetail(contact_info);
    }
    else{
    this.$store.dispatch("ContactInfo", contact_info).then(r => {
    var conta=r.data.docs[0];
     this.Edit_ContDetail(conta);
    });
    }
  }
 editcompanycontact(contact_info)
 {
  //  debugger
   this.$data.editcompany = true;
   let conta = contact_info;
   this.$store.commit("CHANGE_SELECTED_CONTACT", conta);  
   this.$data.activetab = "editcontct";
  this.$store.commit("SET_TEXTMESSAGETAB",this.$data.activetab)
 }
  addressLastLine(selectedContact) {
   //var selectedContact=(this as any).selectedContact;
      if(selectedContact && selectedContact.address) {
          const line1 = selectedContact.address.line1 ? selectedContact.address.line1 : '';
          const line2 = selectedContact.address.line2 ? selectedContact.address.line2 : '';
          const city = selectedContact.address.city ? selectedContact.address.city : '';
          const state = selectedContact.address.state ? selectedContact.address.state : '';
          const zip = selectedContact.address.zip ? selectedContact.address.zip : '';
           return `${line1} ${line2} ${city} ${state} ${zip}`;
      }
      else {
          return null;
      }
  }

   validat_num(Number: any){
       let mob_number = Number//this.$data.NewContact_User.mobile;
       mob_number = mob_number.replace(/[^a-zA-Z0-9]/g, '');
      return mob_number;
    }


 

  formatPhoneNumber(phoneNumber: any) {   
    if(phoneNumber.length == 12){
    phoneNumber=phoneNumber.slice(2, 12);
    }//toString().indexOf("+1");
    if(phoneNumber.length == 10){
      phoneNumber=phoneNumber;
    }
    if(typeof phoneNumber === "number") {
        phoneNumber = phoneNumber.toString();
    }
    //This regex is based off the format of phone numbers
    //as they are returned in the contact list by the Kazoo API.
    //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
    //If the Hellospoke database uses a different format will adjust
    //the pattern accordingly
    phoneNumber=phoneNumber.replace(/[^a-zA-Z0-9]/g, '');

    //for outlook contact mobile number of format issue 1 is added
    if(phoneNumber.length == 11){
     phoneNumber=phoneNumber.slice(1, 11);
    }    
    const re = /(\d{3})(\d{3})(\d{4})/;
    const matches = phoneNumber.match(re);
    if(matches === null) {
            console.log("The phone number " + phoneNumber + " could not be parsed");
        return "";
    }
    return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
  }

  tagFilter()
  {
    let tags = utill.handletag();
    if(tags.length > 0)
    {
      let fullName = [];
      let tagid_arr = tags.map(e=>e._id);
      this.$data.fullNames.forEach((element) => {
        let taglist = [];
        if(element.taglist)
        {
          let currtag = element.taglist
          currtag.forEach((element1) => {
            if(tagid_arr.indexOf(element1) > -1) taglist.push(element1);
          });
        }
        element.taglist = taglist;
        fullName.push(element);
      }); 
      this.$data.fullNames = fullName;
    }
  }
  


  async _GetContacts(type = true )
  {
    
    this.$data.managintab_statusall = false;
    this.$data.contacts=this.$data.fullNames=[]; 
    let notificationContact = JSON.parse((this as any).notificationContact);
  
    this.$store.commit('SET_CONTACT_LOADER', true);
    await this.$store.dispatch("getContacts").then(r => 
    {
    this.$data.loading=false;
    this.$store.commit("SET_CONTACT_LOADER", false);
    this.insertTagCount(r.data.docs);
    
    this.tagFilter(); // remove deleted tag
    console.log('contact sidebar here',(this as any).contactsidebar_status);
  switch((this as any).contactsidebar_status)
    {
      case 'company':
          this.$data.fullNames= this.Sortlist(r.data.Contact_Shared.filter(e=>{ return e.presence_id && (!e.is_kazoo_deleted)}));
          this.$data.mainfullnamearr = this.$data.fullNames;
         
          this.$store.commit("COMPANYCONTACT_LIST",this.$data.mainfullnamearr)
        break;
      case 'shared':
          this.$data.fullNames= this.Sortlist(r.data.Contact_Shared).filter(e=>{ return !e.presence_id && !e.private});
          this.$data.mainfullnamearr = this.$data.fullNames; 
          
          this.$store.commit('SHAREDCONTACT_LIST' ,this.$data.mainfullnamearr);
        break;
      case 'favorites':
          this.$data.fullNames=this.Sortlist(r.data.Contact_Favorite);
           
          this.$data.mainfullnamearr = this.$data.fullNames;
        break;
      case 'personal':
          this.$data.fullNames=this.Sortlist(r.data.Contact_Personal).filter(e=>{ return !e.presence_id && e.private});
         
          var cont =(this as any).selectedContact;
          
          this.$data.mainfullnamearr = this.$data.fullNames;
          if((this as any).textpanelcontact){
          if(type && notificationContact)
          {
            if(notificationContact.last_name && notificationContact.taglist)
            {
            this.$emit('editcontact')
            }
          }
          if(localStorage.mobileNumber){
          this.$emit('newcontact');
          }
          if((this as any).textpannel_contactinfo=='Detail_contact' && (this as any).selectedContact!=null)
          {
            var contct=r.data.docs.filter(e=>{ return e._id==cont._id });
            this.editcontact(contct[0],'Text_panel','');
          }
          this.$store.commit('SET_TEXTPANEL_CONTACT_SELECTION',false);
          }
        break;
      case 'all':
          this.$data.fullNames= this.Sortlist(r.data.docs);
          this.$data.mainfullnamearr = this.$data.fullNames;
          var tagname_listttt=(this as any).tagname;
          console.log('tagname_listttt',tagname_listttt);
            var result = this.$data.fullNames.filter(function (o1) {
              return tagname_listttt.every(function (o2) {
                  return o1.taglist && o1.taglist.includes(o2)
                
            });
          });
           console.log(result);
          this.$data.fullNames=this.Sortlist(result);
          console.log('r.data.docs contact table all finally',this.$data.fullNames);
          //this.$store.commit("COMPANYCONTACT_LIST",this.$data.mainfullnamearr);
        break;
      default:
        this.$data.fullNames= this.Sortlist(r.data.docs);
        this.$data.mainfullnamearr = this.$data.fullNames;
        console.log('r.data.docs contact table all here in this',r);
         //this.$store.commit("COMPANYCONTACT_LIST",this.$data.mainfullnamearr);
      break;
    }
    })
  }



  Edit_ContDetail(conta){  
   // this.$store.commit('SET_TEXTMESSAGETAB','editcontct');
    var USERID=(this as any).User_id;
     this.$data.oldtaglist = conta.taglist ? JSON.parse(JSON.stringify(conta.taglist)) : [];
     this.$store.commit("SET_OLDTAGLIST",this.$data.oldtaglist)
    const created_tags=(this as any).Tag_list_;
     conta.tags1=[];
      if(conta.taglist!=undefined){
      created_tags.forEach((e1)=>conta.taglist.forEach((e2)=> {
          if(e1._id === e2){
          conta.tags1.push(e1);
          }
      }
      ));
      }
     if((typeof conta.address)=="object"){
      conta.address=this.addressLastLine(conta);
    }
     if(conta.Favoritecontact!=undefined && conta.Favoritecontact.length!=0 ){
      conta.Favoritecontact.filter(function (elmt) {
          if(elmt==USERID){
          conta.pvt_cont=true;
          }
          else{
          conta.pvt_cont=false;
          }
      });
      }
      else{
          conta.pvt_cont=false;
      }
      this.$data.selcetdcont_loading='';
      this.$emit('editcontact'); 
      this.$data.editemail_status=false;     
      this.$data.taglist = conta.taglist;
      this.$data.SelectedContInf=conta;
      var phno = this.$data.SelectedContInf.numbers.mobile.number;
      if(this.$data.SelectedContInf.work == undefined) this.$data.SelectedContInf.work = [];
      if(!this.$data.SelectedContInf.work && this.$data.SelectedContInf.work !="")
      {
        this.$data.SelectedContInf.work = [];
        this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:true});
      }
      if(this.$data.SelectedContInf.work.length == 0)
      {
        this.$data.SelectedContInf.work = [];
        this.$data.SelectedContInf.work.push({work:'',extension:'' ,delet:false});
      }
      if(this.$data.SelectedContInf.work.length>=1){
        for(var i=0; i<this.$data.SelectedContInf.work.length; i++){
             this.$data.SelectedContInf.work[i].work=this.validat_num(this.$data.SelectedContInf.work[i].work);
        }
      }
     this.$store.commit("CHANGE_SELECTED_CONTACT", this.$data.SelectedContInf); 
  }
 

  Sortlist(data){
    
  data.sort(function(a, b) { 
    let nameA = '';
    let nameB = '';
    if(a.first_name!=undefined && a.first_name!='')
      nameA = a.first_name.toLowerCase().trim();

    if(b.first_name!=undefined && b.first_name!='')
      nameB = b.first_name.toLowerCase().trim();
    if (nameA < nameB){
      //sort string ascending
      return -1;
    } else {
      return 1;
    }
  });
   return data;
  }
  unselctcontact(dt){
   this.$data.fullNames.forEach(element => {
        element.select=  false;
        let check = element._id;
        let ele = document.getElementById(check);
      ele.classList.remove('checkboxbg');

      })
      this.$data.selectAll=false;
      this.$store.commit("CHANGE_SELECTED_CONTACT", []); 
  }
  
  individual_select(cont,stat){
    this.$data.fullNames.forEach(element => {
          if((element._id==cont._id) && stat ){
          element.select=  true;
          }
      })
      this.$data.selectAll=false;
    	this.$data.multipleselect = this.$data.fullNames.filter(function (el) {
				return el.select == true;
        });
      this.$data.selectAll= this.$data.multipleselect.length==this.$data.fullNames.length?true:false
      this.$store.commit("CHANGE_SELECTED_CONTACT", this.$data.multipleselect); 
  }

  selectall(st){
    this.$data.selected = [];
      this.$data.multipleselect=[];
				for (let i in this.$data.fullNames) {
          //this.$data.contacts[i].select=st;
           this.$data.fullNames[i].select=st; 
          this.$data.multipleselect.push(this.$data.fullNames[i]);
           this.$store.commit("CHANGE_SELECTED_CONTACT", this.$data.multipleselect);  
        }
        if(!st){
          this.$data.multipleselect=[];
          this.$store.commit("CHANGE_SELECTED_CONTACT", this.$data.multipleselect);  
        }
  }

  managint_maintag(type = 'open',tag_contac=[]){  
    console.log('managint_maintag')
    setTimeout(function(){
      this.$store.commit('MANAGING_TAG','MainTag');
    if(type == "open" && this.$data.multipleselect.length>0)
    {
      this.$data.managintab_statusall = true;  
    }
    else
    {
      this.$data.managintab_statusall = false;
    }
    // this.$data.managintab_statusall=!this.$data.managintab_statusall;
    }.bind(this), 500);
  }

  managing_tab(name){
    this.$store.commit('MANAGING_TAG','tableTag');
      var found_conta = this.$data.fullNames.find(function(element) {
        return element._id ==name._id;
      });
      
    this.$store.commit("CHANGE_SELECTED_CONTACT", found_conta);  
   // this.$store.commit('contact_handler', {contact: name, tags: this.$data.taglist});
    this.$data.managintab_status=!this.$data.managintab_status;
  }

}


